export function commercialReturnRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_COMMERCIAL_RETURN_START":           
        case "FETCH_COMMERCIAL_RETURNS_START":           
        case "DELETE_COMMERCIAL_RETURN_START":           
            return {
                ...state, 
                fetching:true
            }        
        case "CREATE_COMMERCIAL_RETURN_FULFILLED":           
        case "FETCH_COMMERCIAL_RETURNS_FULFILLED":           
        case "DELETE_COMMERCIAL_RETURN_FULFILLED":           
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_COMMERCIAL_RETURN_ERROR":
        case "FETCH_COMMERCIAL_RETURNS_ERROR":
        case "DELETE_COMMERCIAL_RETURN_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}